<script lang="ts">
	import { onMount } from "svelte";
	import ContainerLoading from "../v7/components/common/ContainerLoading.svelte";
	import LogoBlack from "../assets/logo_black.png";

	export let error = "";
	export let errorAction = "";
	let showLogin = false;

	onMount(() => {
		var timer = setTimeout(() => (showLogin = true), 2000);
		return () => clearTimeout(timer);
	});
</script>

<div class="loading-background">
	<div class="loading-container">
		{#if error}
			<img class="loading-logo" src={LogoBlack} alt="logo" />
			<div class="loading-error">ERROR</div>
			<div class="loading-desc">{error}</div>
			<div on:click class="loading-link">{errorAction} →</div>
		{:else if showLogin}
			<ContainerLoading />
		{/if}
	</div>
</div>

<style lang="scss">
	.loading-background {
		display: flex;
		width: 100%;
		min-height: 100vh;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.loading-container {
		max-width: 10em;
	}

	.loading-logo {
		display: block;
		width: 100%;
		max-width: 7rem;
		margin-bottom: 2rem;
	}

	.loading-error {
		position: relative;
		margin-top: 1rem;
		font-weight: bold;
	}

	.loading-error::before {
		position: absolute;
		top: 0;
		left: -2em;
		display: flex;
		width: 1.2em;
		height: 1.2em;
		align-items: center;
		justify-content: center;
		border: 2px solid var(--black);
		border-radius: 999px;
		content: "!";
		font-size: 1.3em;
		font-weight: 400;
	}

	.loading-desc {
		margin-top: 0.5rem;
		margin-bottom: 1.5rem;
	}

	.loading-link {
		color: var(--blue);
		cursor: pointer;

		&:hover {
			text-decoration: underline;
		}
	}
</style>
